<!--<div class="main">

<button class="btn btn-primary"(click)="goToLogin()">login</button>
<button class="btn btn-primary"(click)="goToDasboard()">dashboard</button>
<router-outlet></router-outlet>
</div>-->


<!--<button class="btn-accent-2">Add</button>
<button class="btn-primary-custom">Edit</button>
<button class="btn-secondary">Delete</button>
<button class="btn-accent">Crear nuevo</button> 
<button class="btn-gradient">Save</button>
<button class="btn-primary-custom-outline ">Cancelar</button>
<button class="btn-outline-gradient">Cancelar</button>-->





<router-outlet></router-outlet>
